import { Outlet } from "react-router-dom";
import React,{useState} from "react";
import Header from "./components/Header/Header";
import LeftSideBar from "./components/Sidebar/LeftSideBar";
import SpringMoneySideBar from "./components/SpringMoney/Sidebar/SpringMoneySidebar";

const Main = () => {
  const [isSidebarVisible, setIsSidebarVisible] = useState<Boolean>(false);

  const handleOutsideClick = (e : any) => {
    if (e.target.id === 'left_side_bar') {
      setIsSidebarVisible(false);
    }
  };
  return (
    <>
      <div className="page-start" id="page_container">
        <div id="left_side_bar" onClick={handleOutsideClick} className={`${isSidebarVisible ? '' : 'hidden'} md:fixed md:z-[1000] md:w-[100%]  bg-[#00000080]`}>
          <div className=" md:w-[270px]">
            {process.env.REACT_APP_LEFT_SIDE_BAR_SPRING_MONEY === "true" ? (
              <SpringMoneySideBar setIsSidebarVisible={setIsSidebarVisible}/>
            ) : (
              <LeftSideBar />
            )}
          </div>
        </div>
        <div
          id="header_plus_content_container"
          className="flex flex-1 flex-col  page-content-body"
        >
          <Header setIsSidebarVisible={setIsSidebarVisible}/>
          <div className="flex-1 content-main">
            <div className="pagge-inner-padding">
              <div className="page-content-wraper">
                <div id="main-app">
                  <Outlet />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Main;
